export default {
  rawColumns:[
  {
    dataIndex:'rawName',
    title:'原料名称',
    width: 120,
    align: 'left',
    ellipsis: true,
    scopedSlots: {customRender: 'rawName'},
  },
  {
    dataIndex:'rawCode',
    title:'原料代码',
    ellipsis: true,
    width:100,
  },
  {
    dataIndex:'price',
    title:'历史价格(元/吨)',
    ellipsis: true,
    scopedSlots: {customRender: 'price'},
    width:100
  },
  {
    dataIndex:'newestPrice',
    title:'最新价格(元/吨)',
    scopedSlots: {customRender: 'newestPrice'},
    ellipsis: true,
    width:100
  },
  {
    dataIndex:'diffPrice',
    title:'差异(元/吨)',
    scopedSlots: {customRender: 'diffPrice'},
    width:100
  },
  {
    dataIndex:'percentage',
    title:'用量(%)',
    ellipsis: true,
    scopedSlots: {customRender: 'percentage'},
    width:100
  },
  {
    dataIndex:'uasge',
    title:'用量(批次量)',
    ellipsis: true,
    scopedSlots: {customRender: 'uasge'},
    width:100
  },{
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width:100
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width:100
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minLimitValue'},
    width:100
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxLimitValue'},
    width:100
  },
],
  nutColumns:[
  {
    dataIndex:'name',
    title:'指标名称',
    width:120,
    ellipsis: true,
  },
  {
    dataIndex:'content',
    title:'数值',
    width:100,
    ellipsis: true,
    scopedSlots: {customRender: 'content'},
  },
  {
    dataIndex:'unit',
    title:'单位',
    width:100,
    ellipsis: true,
  },
  {
    dataIndex:'minValue',
    title: '最小值',
    ellipsis: true,
    scopedSlots: {customRender: 'minValue'},
    width:100
  },
  {
    dataIndex:'maxValue',
    title: '最大值',
    ellipsis: true,
    scopedSlots: {customRender: 'maxValue'},
    width:100
  },
  {
    dataIndex:'minLimitValue',
    title: '极下限',
    ellipsis: true,
    scopedSlots: {customRender: 'minLimitValue'},
    width:100
  },
  {
    dataIndex:'maxLimitValue',
    title:'极上限',
    ellipsis: true,
    scopedSlots: {customRender: 'maxLimitValue'},
    width:100
  },
]}
